import { useState, useEffect } from 'react';
import { getLoginState } from 'model/user';
import repo from 'service/repository';
import mqtt from 'service/mqtt';
import { INIT_APP_DONE, UPDATE_BOOTSTRAPS } from 'use-app';
import { PATH } from 'config';
import qs from 'query-string';
import { getAuth, saveAuth, getIknow99IsBinded, saveIknow99IsBinded } from 'service/local-data-provider';

const useInit = () => {
  const [isPending, setIsPending] = useState(true);

  useEffect(() => {
    setIsPending(false);

    return () => {
      mqtt.disconnect();
    };
  }, []);

  return {
    isPending,
  };
};

const loginAsUser = (success, failure) => {
  return Promise.all([
    repo.fetchUserInfo(),
    repo.fetchLicensePlates(),
    repo.fetchBootstraps(),
    repo.fetchParkingRecord(),
    repo.fetchOrders(1, 100, ['refueling']),
    repo.fetchOrders(1, 100, ['parking']),
    repo.agreeTermsOfTaipeiParkinglotService(),
  ])
    .then(data => {
      const payload = {
        me: data[0],
        licensePlates: data[1],
        bootstraps: data[2],
        parkingRecord: data[3],
        orders: {
          refueling: data[4].data,
          parking: data[5].data,
        },
      };

      success(payload);
    })
    .catch(e => {
      failure(e);
    });
};

const useSplash = async ({ dispatch, history, location }, callback) => {
  const initAppWithoutPayload = () => dispatch({ type: INIT_APP_DONE });

  const waitForSplashAnimationComplete = fn => {
    return new Promise(resolve => {
      resolve(callback());
    }).then(() => {
      setTimeout(() => fn(), 2200);
    });
  };

  await repo.fetchBootstraps().then(payload => {
    dispatch({
      type: UPDATE_BOOTSTRAPS,
      payload,
    });
  });

  if (
    location.pathname === PATH.EXPIRED ||
    location.pathname === PATH.SERVICE_INSTRUCTION ||
    location.pathname === PATH.MAPS
  ) {
    return waitForSplashAnimationComplete(initAppWithoutPayload);
  }

  const searchQuery = qs.parse(location.search);
  if (searchQuery.OneTimeToken) {
    await repo
      .fetchOneTimeToken(searchQuery.OneTimeToken)
      .then(value => {
        saveAuth(value);
      })
      .catch(e => {
        console.log(e);
      });
  }

  const success = payload => {
    waitForSplashAnimationComplete(() => {
      dispatch({
        type: INIT_APP_DONE,
        payload: payload,
      });

      if (getIknow99IsBinded()) {
        if (location.pathname === '/' || location.pathname === '/index.html') {
          history.replace(PATH.MAIN);
        } else {
          history.replace(`${location.pathname}${location.search}${location.hash}`);
        }
      } else {
        saveIknow99IsBinded();
        if (payload.me.currentCreditCard) {
          history.replace(PATH.MAIN);
        } else {
          history.replace(PATH.USER_WELCOME);
        }
      }
    });
  };

  const failure = () => {
    waitForSplashAnimationComplete(() => {
      initAppWithoutPayload();
      history.replace(PATH.MAIN);
      // NEED FIX
      // 要想一下 iknow99 登入拉資料失敗的情境
    });
  };

  // 情境
  // 1. 為已綁定的使用者（已存入 token）
  // 2. 尚未綁定，為首次進入的使用者（已從網址取得 token ）
  // 3. 位綁定，也未取得 token
  if (getLoginState() === 'user' || getAuth()?.accessToken) {
    loginAsUser(success, failure);
  } else {
    waitForSplashAnimationComplete(() => {
      initAppWithoutPayload();
      history.push(PATH.EXPIRED);
    });
  }
};

const methods = {
  useInit,
  useSplash,
  loginAsUser,
};

export default methods;
